export default {
  chatState: state => state.chat,
  videoCallState: state => state.videoCall
}
